import { useEffect } from 'react';

import useRafState from './use-raf-state';

interface WindowSize {
  width: number;
  height: number;
}

const isBrowser = typeof window !== 'undefined';

const useWindowSize = (initialWidth = Infinity, initialHeight = Infinity): WindowSize => {
  const [windowSize, setWindowSize] = useRafState<WindowSize>({
    width: isBrowser ? document.documentElement.clientWidth : initialWidth,
    height: isBrowser ? document.documentElement.clientHeight : initialHeight,
  });

  useEffect((): (() => void) | void => {
    function onResize() {
      setWindowSize({
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
      });
    }

    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [setWindowSize]);

  return windowSize;
};

export default useWindowSize;
